import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { onboardingservice } from '../onboarding.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-onboarding-forgetpassword',
  templateUrl: './onboarding-forgetpassword.component.html',
  styleUrls: ['./onboarding-forgetpassword.component.scss']
})
export class OnboardingForgetpasswordComponent implements OnInit {

  type:string = "";
  email:string ="";
  LoginForm:FormGroup;
  @Output() newItemEvent = new EventEmitter<string>();
  page:string='forgetpassword'
  constructor(private formBuilder:FormBuilder,public httpService: onboardingservice,
    public toastrService: ToastrService,
    public global: GlobalComponent, ) {
    this.LoginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      agencycode: ['', Validators.required],
    });
   }
   employeelogin: Boolean = false;
   clientlogin: Boolean = false;
   
   ngOnInit(): void {
    var url = window.location.href;
    this.employeelogin = url.includes('/onboarding/employee');
    this.clientlogin = url.includes('/onboarding/client');   
  }
  
  forgotpasswordonboard()
  {
    this.global.OnboardingLoginType = "OnboardingLoginType";
    if (this.clientlogin != false && this.employeelogin == false) {
      this.type= "client";
    }
    else if (this.clientlogin == false && this.employeelogin != false) {      

      this.type= "employee";
    }


  this.forgotpassword();
   }
  
   

  
   forgotpassword() {
   
    let params = new URLSearchParams();   
    
    params.append("type",this.type);
    params.append("Email",this.LoginForm.value.Email);
    params.append("AgencyCode",this.LoginForm.value.agencycode);
    this.httpService.forgotPasswordclient(params).subscribe((data: any) => {
      if (data) {
        this.toastrService.success('Temporary password has been sent to your respective mail id',
          'Temporary password sent successfully'), 8000;
      this.cancel();
      }
    
      
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }


 


 




  MoveToNextPage(page: string) {
    this.page = page;
    this.newItemEvent.emit(this.page);
  }
  cancel() {
    this.page = 'login';
    this.newItemEvent.emit(this.page);
  }
}
